import React, { useState } from 'react'
import { Modal, notification } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import TextArea from 'antd/lib/input/TextArea'

import { acceptUpdatedTerms } from 'src/core/store/ducks/me/actions'
import { ApplicationState } from 'src/store'
import * as MeService from 'src/services/api/me'
import useDocumentTitle from 'src/hooks/use-document-title'

import * as CSS from './styles'
import termsAndPrivacyPolicy from './terms-and-privacy-policy'

export default function UpdateTermsAndPrivacyPolicyModal() {
  useDocumentTitle('common.terms.title')

  const { me } = useSelector((state: ApplicationState) => ({
    me: state.me
  }))

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const [accept, setAccept] = useState<boolean>(false)

  function logout(): void {
    localStorage.clear()
    window.location.replace('/')
  }

  const cancelText = t('web.side.user.logout')
  const checkboxText = t('common.terms.checkbox')
  const notificationMessage = t('common.response.unexpected-error')
  const okText = t('common.actions.continue')
  const titleModal = t('common.terms.title')

  const { agree_terms, user_id } = me.user

  return (
    <Modal
      cancelText={cancelText}
      closable={false}
      maskClosable={false}
      maskStyle={CSS.ModalMask}
      okButtonProps={{ disabled: !accept }}
      okText={okText}
      onCancel={logout}
      onOk={async () => {
        if (accept && user_id) {
          const response = await MeService.acceptanceOfTheTerms(user_id)
          if (response.status === 200) {
            dispatch(acceptUpdatedTerms())
          } else {
            notification.error({
              message: notificationMessage,
              placement: 'bottomRight'
            })
          }
        }
      }}
      title={titleModal}
      visible={!agree_terms}
      width={700}
    >
      <TextArea rows={10} value={termsAndPrivacyPolicy} />
      <CSS.Checkbox
        onChange={({ target }) => {
          setAccept(target.checked)
        }}
      >
        {checkboxText}
      </CSS.Checkbox>
    </Modal>
  )
}
